import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import logo from '../logo.svg'
import '../styles/Header.css'

function Header() {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const role = (sessionStorage.getItem('role') || '').toUpperCase()
  const canSeeAdminLinks = role === 'ADMIN' || role === 'WHOLESALER' || role === 'WHORLASES' || role === 'DISTRIBUTOR'
  const canSeeUsers = role === 'ADMIN' || role === 'WHOLESALER'
  const canSeeCore = role === 'ADMIN'




  const toggle = () => setIsOpen(!isOpen)
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const handleLogout = () => {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('role')
    navigate('/', { replace: true })
  }

  const handleHome = () => {
    navigate('/index')
  }

  const handleInstances = () => {
    navigate('/index')
  }

  const handleDistributors = () => {
    navigate('/distributors')
  }

  const handleUsers = () => {
    navigate('/users')
  }

  const handleCore = () => {
    navigate('/core')
  }

 const handlePassword = () => {
    navigate('/password')
 
}



  return (
    <Navbar expand="md" className="navbar-custom">
      <div className="navbar-container">
        <NavbarBrand onClick={handleHome} className="navbar-brand-custom">
          <img src={logo} alt="" className="navbar-logo-img" />
          <span className="navbar-brand-text">
            <span className="navbar-logo">Flexihora</span>
            <span className="navbar-subtitle">Backoffice</span>
          </span>
        </NavbarBrand>

        <NavbarToggler onClick={toggle} className="navbar-toggler-custom" />

        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle nav caret className="user-dropdown">
                <span className="user-icon">👤</span>
              </DropdownToggle>
              <DropdownMenu end className="dropdown-menu-custom">
                <DropdownItem header className="dropdown-header-custom">
                  Opciones de Usuario
                </DropdownItem>
                <DropdownItem onClick={handlePassword}>
                      Contraseña
                </DropdownItem>
                {canSeeAdminLinks && (
                  <>
                    <DropdownItem onClick={handleInstances}>
                      Instancias
                    </DropdownItem>
                    <DropdownItem onClick={handleDistributors}>
                      Distribuidores
                    </DropdownItem>
                  </>
                )}
                {canSeeUsers && (
                  <DropdownItem onClick={handleUsers}>
                    Users
                  </DropdownItem>
                )}
                {canSeeCore && (
                  <DropdownItem onClick={handleCore}>
                    Core
                  </DropdownItem>
                )}
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout} className="logout-item">
                  <span className="logout-icon">🚪</span>
                  Cerrar Sesión
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </Collapse>
      </div>
    </Navbar>
  )
}

export default Header
